import { Injectable } from "@angular/core";
import { DbTableDefinition } from "src/app/_services/persistence/db-persistence/db-table-definition";

@Injectable({
  providedIn: 'root'
})
export class TourStopDbTableDefinition extends DbTableDefinition {
    tableName = 'tourstops';
    tableStructure = `(id BIGINT(20) PRIMARY KEY null,
       label TEXT NOT NULL,
       databag LONGTEXT,
       tourid BIGINT(20),
       tourlabel TEXT
      );`;

      constructor() {
        super();
        // Add UpdateStatements to Map
      }
}